import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Loader2 } from "lucide-react"
import { apiClient } from "@/lib/api-client"
import { useToast } from "@/hooks/use-toast"

export default function LoginPage() {
  const navigate = useNavigate()
  const [email, setEmail] = useState("admin@example.com")
  const [password, setPassword] = useState("admin123456")
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { toast } = useToast()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setIsLoading(true)

    try {
      if (!email || !password) {
        setError("Email e senha são obrigatórios")
        return
      }

      const response = await apiClient.login({
        email,
        password,
      })

      if (response.data.access_token) {
        // Limpar localStorage de login anterior
        localStorage.removeItem("userEmail")
        localStorage.setItem("userEmail", email)
        navigate("/")
      }
    } catch (err: any) {
      const errorMsg =
        err.response?.data?.detail ||
        err.message ||
        "Erro ao fazer login"

      setError(errorMsg)
      toast({
        title: "Erro de Autenticação",
        description: errorMsg,
        variant: "destructive",
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="w-full flex flex-col items-center py-4 sm:py-6 px-2 sm:px-6 min-h-screen">
      <Card className="w-full max-w-lg p-6 sm:p-10 shadow-2xl border-purple-500/20 bg-gradient-to-br from-slate-900/95 to-purple-900/40 backdrop-blur-sm mt-8 sm:mt-0">
        <div className="space-y-8">
          <div className="text-center space-y-3">
            <h1 className="text-4xl sm:text-5xl font-bold tracking-tight bg-gradient-to-r from-purple-300 via-pink-300 to-purple-200 bg-clip-text text-transparent">
              PE-SRT Content Machine
            </h1>
            <p className="text-purple-100 text-lg sm:text-xl">Sistema de Geração de Conteúdo Visual</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-3">
              <Label htmlFor="email" className="text-purple-50 text-lg sm:text-lg font-semibold">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="admin@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isLoading}
                required
                className="border-purple-500/40 bg-purple-950/40 text-purple-50 placeholder:text-purple-300/40 text-lg h-16 px-4"
              />
            </div>

            <div className="space-y-3">
              <Label htmlFor="password" className="text-purple-50 text-lg sm:text-lg font-semibold">Senha</Label>
              <Input
                id="password"
                type="password"
                placeholder="Sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
                required
                className="border-purple-500/40 bg-purple-950/40 text-purple-50 placeholder:text-purple-300/40 text-lg h-16 px-4"
              />
            </div>

            {error && (
              <div className="p-4 bg-red-500/10 border border-red-500/30 rounded-md text-lg text-red-400">
                {error}
              </div>
            )}

            <Button
              type="submit"
              disabled={isLoading}
              className="w-full h-16 text-lg sm:text-lg font-semibold bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700"
            >
              {isLoading ? (
                <>
                  <Loader2 className="mr-2 h-6 w-6 animate-spin" />
                  Entrando...
                </>
              ) : (
                "Entrar"
              )}
            </Button>
          </form>

          <div className="space-y-4 text-base sm:text-base text-purple-200 border-t border-purple-500/20 pt-6">
            <div>
              <p className="font-semibold text-purple-50 mb-3 text-lg">Dados de Teste:</p>
              <ul className="space-y-2 text-base">
                <li><strong>Email:</strong> admin@example.com</li>
                <li><strong>Senha:</strong> Definida no init_admin.py</li>
              </ul>
            </div>

            <div className="bg-purple-600/20 p-4 rounded-md border border-purple-500/40">
              <p className="text-base">
                💡 <strong>Dica:</strong> Backend deve estar em http://localhost:8075
              </p>
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}


